import '.l{display:flex;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.n{gap:0.5rem;}.ssr-plugin'
import '.bu{cursor:pointer;}.ssr-plugin'
import '.ea{padding:0.75rem;}.ssr-plugin'
import '.b1{border-radius:1.25rem;}.ssr-plugin'
import '.bp{border:var(--border-subtle);}.ssr-plugin'
import '.b2{background-color:var(--palette-white);}.ssr-plugin'
import '.co{transition:background-color 0.2s ease;}.ssr-plugin'
import '.er{width:2.5rem;}.ssr-plugin'
import '.es{height:2.5rem;}.ssr-plugin'
import '.iu{color:var(--palette-blue-700);}.ssr-plugin'
import '.iv{font-size:0.9rem;}.ssr-plugin'
import '.bc{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="l a1 m aa n bu ea b1 bp b2 co"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="er es l aa a1 iu"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="iv iu bc"
        >
          {label}
        </span>
      </styled.button>
    )
}